import ApiService from './ApiService.js'

let querystring = require('querystring')


export default {
    getHeader() {
        let token = btoa((window.app.client + ':' + window.app.secret));
        return {
            "Authorization": "Basic " + token,
            'Content-Type': 'application/x-www-form-urlencoded',
            "Accept": "application/json"
        };
    },
    requestToken(input) {
        let header = this.getHeader();
        return ApiService().post('api/token', 
        querystring.stringify({ 
            'grant_type': 'password',
            'scope': 'read',
            'username': input.username,
            'password': input.password
        }),
        { 
            headers: header
        });
    },
    refreshToken() {
        let header = this.getHeader();
        
        return ApiService().post('api/token', 
        querystring.stringify({ 
            'grant_type': 'refresh_token',
            'scope': 'read',
            'refresh_token': localStorage.getItem('refresh_token')
        }),
        { 
            headers: header
        });
    }
}